import axios from "@/utils/axios";

import {
  keepPreviousData,
  useInfiniteQuery,
  useQuery,
} from "@tanstack/react-query";

export const useGetUserPositions = () => {
  return useQuery({
    queryKey: ["user-positions"],
    queryFn: async () => {
      const response = await axios.get(
        "/admin/v1/data-center/sources/OPERADOR/tables/data",
        {
          params: {
            table_name: "cargos",
          },
        },
      );
      return response.data;
    },
    refetchOnWindowFocus: false,
  });
};

export const useGetUserOrganizations = () => {
  return useQuery({
    queryKey: ["user-organizations"],
    queryFn: async () => {
      const response = await axios.get(
        `/admin/v1/data-center/sources/OPERADOR/tables/data`,
        {
          params: {
            table_name: "instituciones",
          },
        },
      );
      return response.data;
    },
    refetchOnWindowFocus: false,
  });
};

export const useGetUserPositionsAsInfinite = (filters: { search?: string }) => {
  return useInfiniteQuery({
    queryKey: ["user-positions-infinite", filters],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await axios.get(
        "/admin/v1/data-center/sources/OPERADOR/tables/data",
        {
          params: {
            table_name: "cargos",
            paginate: 1,
            page: pageParam,
            per_page: 80,
            ...(filters.search && {
              filter: { search: filters.search },
            }),
          },
        },
      );
      const payload = response.data;
      let rows: unknown[] = [];
      if (Array.isArray(payload?.data)) {
        rows = payload.data;
      } else if (Array.isArray(payload?.data?.data)) {
        rows = payload.data.data;
      }
      const meta = payload?.meta || payload?.data?.meta || {};
      return {
        data: rows,
        meta,
      };
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const meta = (
        lastPage as { meta?: { current_page?: number; last_page?: number } }
      ).meta;
      if (
        meta?.current_page !== undefined &&
        meta?.last_page !== undefined &&
        meta.current_page < meta.last_page
      ) {
        return meta.current_page + 1;
      }
    },
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
};

export const useGetUserOrganizationsAsInfinite = (filters: {
  search?: string;
}) => {
  return useInfiniteQuery({
    queryKey: ["user-organizations-infinite", filters],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await axios.get(
        `/admin/v1/data-center/sources/OPERADOR/tables/data`,
        {
          params: {
            table_name: "instituciones",
            paginate: 1,
            page: pageParam,
            per_page: 80,
            ...(filters.search && {
              filter: { search: filters.search },
            }),
          },
        },
      );
      const payload = response.data;
      let rows: unknown[] = [];
      if (Array.isArray(payload?.data)) {
        rows = payload.data;
      } else if (Array.isArray(payload?.data?.data)) {
        rows = payload.data.data;
      }
      const meta = payload?.meta || payload?.data?.meta || {};
      return {
        data: rows,
        meta,
      };
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const meta = (
        lastPage as { meta?: { current_page?: number; last_page?: number } }
      ).meta;
      if (
        meta?.current_page !== undefined &&
        meta?.last_page !== undefined &&
        meta.current_page < meta.last_page
      ) {
        return meta.current_page + 1;
      }
    },
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
};

export const useGetUserUnits = () => {
  return useQuery({
    queryKey: ["user-units"],
    queryFn: async () => {
      const response = await axios.get(
        "/admin/v1/data-center/sources/OPERADOR/tables/data",
        {
          params: {
            table_name: "departamentos",
          },
        },
      );
      return response.data;
    },
    refetchOnWindowFocus: false,
  });
};
